<app-base-button
  data-testid="btnGoBack"
  [outlined]="true"
  [label]="label"
  (onClick)="handleCancel()"
  class="cursor-pointer"
>
</app-base-button>
